import { PropsWithChildren, useCallback, useRef } from 'react';

import { BuilderStepNavigationContext } from '@features/campaigns/builder/providers/BuilderStepNavigationProvider/providerSetup.ts';
import { logError } from '@shared/utils/logError.ts';

export function BuilderStepNavigationProvider({ children }: PropsWithChildren) {
  const handlerRef = useRef<((targetStepIndex: number) => Promise<void>) | null>(null);
  const pendingNavigationTargetRef = useRef<number | null>(null);

  const requestNavigationToStep = useCallback((targetStepIndex: number) => {
    if (handlerRef.current) {
      void handlerRef.current(targetStepIndex).catch(logError);
    }
  }, []);

  const registerNavigationHandler = useCallback((handler: ((targetStepIndex: number) => Promise<void>) | null) => {
    handlerRef.current = handler;
  }, []);

  const clearPendingNavigationTarget = useCallback(() => {
    pendingNavigationTargetRef.current = null;
  }, []);

  return (
    <BuilderStepNavigationContext.Provider
      value={{
        requestNavigationToStep,
        registerNavigationHandler,
        pendingNavigationTargetRef,
        clearPendingNavigationTarget,
      }}
    >
      {children}
    </BuilderStepNavigationContext.Provider>
  );
}
